webpackJsonp([6],{

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(314);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e0aab3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(383);
function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var normalizeComponent = __webpack_require__(118)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56e0aab3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56e0aab3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BackNavigationComponent__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ThemeSwitcher__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer__ = __webpack_require__(281);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var messages = {
  en: {
    message: {
      pageTitle: 'Privacy Policy'
    }
  },
  hi: {
    message: {
      pageTitle: 'गोपनीयता नीति'
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: typeof Storage !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
  messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: i18n,
  components: {
    backNavigator: __WEBPACK_IMPORTED_MODULE_2__BackNavigationComponent__["a" /* default */],
    themeSwitcher: __WEBPACK_IMPORTED_MODULE_3__ThemeSwitcher__["a" /* default */],
    footerComponent: __WEBPACK_IMPORTED_MODULE_4__Footer__["a" /* default */]
  },
  data: function data() {
    return {
      userLocale: i18n.locale
    };
  },
  mounted: function mounted() {
    document.title = i18n.t('message.pageTitle');
    this.userLocale = i18n.locale;
  }
});

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdl-layout mdl-js-layout mdl-layout--fixed-header"},[_c('header',{staticClass:"mdl-layout__header"},[_c('div',{staticClass:"mdl-layout__header-row page-header"},[_c('back-navigator'),_vm._v(" "),_c('span',{staticClass:"mdl-layout-title",attrs:{"id":"toolbar-title"}},[_vm._v(_vm._s(_vm.$t('message.pageTitle')))]),_vm._v(" "),_c('div',{staticClass:"mdl-layout-spacer"}),_vm._v(" "),_c('theme-switcher',{attrs:{"iconTheme":"light","userLang":_vm.userLocale}})],1)]),_vm._v(" "),_c('div',{staticClass:"horizontalLine"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('footer-component')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-policy-content"},[_c('h6',[_c('i',[_vm._v("Last updated: March 2, 2026")])]),_vm._v(" "),_c('h6',[_vm._v("This Privacy Policy explains how Pollscape collects, uses and transfers your\n      information.")]),_vm._v(" "),_c('h5',{attrs:{"id":"what-is-collected"}},[_c('b',[_vm._v("What do we collect?")]),_vm._v(" ("),_c('a',{attrs:{"href":"privacyPolicy#what-is-collected"}},[_vm._v("link")]),_vm._v(")")]),_vm._v(" "),_c('ul',[_c('li',[_c('h6',[_vm._v("These are the only personally identifiable information that we collect:")])]),_vm._v(" "),_c('ul',[_c('li',[_c('h6',[_vm._v("The email-id of the Google or Facebook account you use to sign-in")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("Profile image for the above mentioned Google/Facebook account")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("User name for the above mentioned Google/Facebook account")])])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("When you vote for an anonymous poll, we use your IP address to check if you have already voted for the poll. Hence, we also store it in the database.\n          However, your IP address is not linked to your user profile in any manner even after you sign in. It is just used to prevent duplicate votes.\n        ")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("Anonymous usage statistics are collected through Google Analytics in order to improve the app. You can check the "),_c('a',{attrs:{"href":"/cookiePolicy"}},[_vm._v("cookie policy")]),_vm._v(" for more details.")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("The Android app for Pollscape uses Admob by Google and Facebook Audience Network to display ads. Since, the app does not have any access to personal\n          information like location, contacts, SMS, etc., the ad network doesn't have access to those information as\n          well. You can choose to receive targeted ads or not from the app GDPR popup.\n        ")])]),_vm._v(" "),_c('ul',[_c('li',[_c('h6',[_vm._v("Admob is an advertising service provided by Admob Google Inc. Personal data collected: Cookie and\n              usage data. Place of processing: USA ("),_c('a',{attrs:{"href":"https://www.google.com/policies/privacy/"}},[_vm._v("Privacy Policy")]),_vm._v(")\n          ")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("\n            Facebook Audience Network is an advertising service provided by Facebook. Personal Data collected: Cookie and Usage Data. Place of processing: USA ("),_c('a',{attrs:{"href":"https://www.facebook.com/about/privacy"}},[_vm._v("Privacy policy")]),_vm._v(").\n          ")])])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("The Android app also collects anonymous usage statistics and crash reports to improve the app. You can turn it on/off anytime by going to the app's settings page.")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("Pollscape developer can ask you for some additional information when trying to debug issues in the app.\n          These information will only be used to solve the issue at hand. Nothing will be shared with any 3rd party\n          service.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',{attrs:{"id":"exporting-data"}},[_c('b',[_vm._v("Exporting your data")]),_vm._v(" ("),_c('a',{attrs:{"href":"privacyPolicy#exporting-data"}},[_vm._v("link")]),_vm._v(")")]),_vm._v(" "),_c('ul',[_c('li',[_c('h6',[_vm._v("You can export a copy of the data of your Pollscape account if you want to \n        back it up or use it with a service other than Pollscape.")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("To export your data, head over to the "),_c('a',{attrs:{"href":"/userProfile"}},[_vm._v("user profile")]),_vm._v(" \n        page and click on 'Export Data' button.")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',{attrs:{"id":"deletion-policy"}},[_c('b',[_vm._v("Data Deletion Policy")]),_vm._v(" ("),_c('a',{attrs:{"href":"privacyPolicy#deletion-policy"}},[_vm._v("link")]),_vm._v(")")]),_vm._v(" "),_c('ul',[_c('li',[_c('h6',[_vm._v("You can choose to delete your data from Pollscape anytime you want by visiting \n        the "),_c('a',{attrs:{"href":"/userProfile"}},[_vm._v("user profile")]),_vm._v(" page and clicking on 'Delete Account' button.\n        All the polls you have created along with all your personal details will be deleted \n        within 30 days of your request.")])]),_vm._v(" "),_c('li',[_c('h6',[_vm._v("We do have an inactive account policy according to which, accounts that are inactive\n        for longer periods of time will be automatically deleted. To prevent this from happening, we\n        suggest you to log in and use Pollscape at least once every 18 months.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/6.226a3e5f481624b33362.js